import { OktaAuth } from '@okta/okta-auth-js';
export const oktaAuthConfig = {
    clientId: '0oaltbigmp1DaYdAl5d7',
    issuer: 'https://dev-35896791.okta.com/oauth2/default',
    redirectUri:`${window.location.origin}/login/callback`,
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
  };
  
export const oktaAuth = new OktaAuth(oktaAuthConfig);